import styled from 'styled-components';

const MenuItemStyle = styled.li`
	--menuItemMarginH: var(--sp7x);
	--menuItemIconMarginLeft: var(--sp1x);
	--menuInnerContPaddingH: var(--sp8x);
	--menuInnerContPaddingV: var(--sp9x);

	//! Inner Menu Item
	--innerMenuItemMarginBottom: var(--sp6x);
	--innerMenuItemSpace: var(--menuInnerContPaddingH);

	//! Icon Menu
	--iconMenuMaxWidth: var(--sp102x);
	--iconMenuItemMarginBottom: var(--sp4x);
	--iconMenuImageSize: var(--sp5x);
	--iconMenuImageMarginRight: var(--sp2x);

	//! Sub Menu
	--subMenuGroupMarginBottom: var(--sp7x);
	--subMenuMaxWidth: var(--sp190x);

	//! Info Menu
	--infoMenuMaxWidth: var(--sp190x);
	--infoMenuMaxWidthLangDe: var(--sp190x);
	--infoMenuMarginTop: var(--sp16x);
	--infoMenuImageWidth: 33.38%;
	--infoMenuImageProportion: 57.75%;
	--infoMenuInfoMarginLeft: var(--sp10x);
	--infoMenuTitleMarginBottom: var(--sp3x);

	//! Default Menu
	--defaultMenuMaxWidth: var(--sp100x);
	--menuRightPosition: calc(-1 * var(--sp2x));

	&.menu-item-cont {
		position: relative;
		display: flex;
		align-items: center;
		height: 100%;
		margin: 0 calc(var(--menuItemMarginH) / 2);
		transition: all var(--trTime);
		cursor: pointer;

		&.lang-de {
			.info-menu {
				max-width: var(--infoMenuMaxWidthLangDe);
			}
		}
	}

	> span,
	> [class^='giz-'] {
		transition: all var(--trTime);
	}

	&:last-child {
		margin-right: 0;
	}

	> [class^='giz-'] {
		margin-left: var(--menuItemIconMarginLeft);
	}

	.menu-inner-cont {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		position: absolute;
		top: calc(100% + var(--headerPaddingV));

		/* right: var(--menuRightPosition); */
		/* transform: translateX(20%); */

		left: 50%;
		transform: translateX(-50%);

		width: 100vw;
		padding: var(--menuInnerContPaddingV) calc(var(--menuInnerContPaddingH) - var(--innerMenuItemSpace) / 2) calc(var(--menuInnerContPaddingV) - var(--innerMenuItemMarginBottom));
		color: var(--primaryColor1);
		background: var(--primaryColor3);
		border: 1px solid var(--borderColor);
		border-radius: var(--sp2x);
		opacity: 0;
		pointer-events: none;
		transition: color var(--trTime);
		cursor: default;

		.menu-inner-item {
			color: var(--secondaryColor2);
			transition: color var(--trTime);

			.link-item {
				display: inline-flex;
			}

			&:not(.sub-menu-inner-item) {
				padding: 0 calc(var(--innerMenuItemSpace) / 2);
				margin-bottom: var(--innerMenuItemMarginBottom);
			}

			&:not(.sub-menu-inner-item):hover,
			&.active {
				color: var(--primaryColor1) !important;

				.menu-inner-item {
					color: var(--primaryColor1) !important;
				}
			}

			&.active {
				.link-item {
					pointer-events: none;
				}
			}
		}

		//! Icon Menu
		&.icon-menu {
			max-width: var(--iconMenuMaxWidth);

			.menu-inner-item {
				width: 50%;
				margin-bottom: var(--iconMenuItemMarginBottom);

				.link-item {
					display: inline-flex;
					align-items: center;
				}

				i {
					font-size: var(--iconMenuImageSize);
					margin-right: var(--iconMenuImageMarginRight);
				}
			}
		}

		//! Sub Menu
		&.sub-menu {
			max-width: var(--subMenuMaxWidth);
			align-items: flex-start;

			.sub-menu-title {
				padding: 0 calc(var(--innerMenuItemSpace) / 2);
				margin-bottom: var(--subMenuGroupMarginBottom);
			}

			.sub-menu-inner-item {
				width: 25%;

				.sub-menu-items {
					display: flex;
					flex-direction: column;
				}
			}
		}

		//! Info Menu
		&.info-menu {
			max-width: var(--infoMenuMaxWidth);

			.menu-inner-item {
				width: 25%;
			}

			.menu-inner-item-info {
				position: relative;
				width: 100%;
				margin: calc(var(--infoMenuMarginTop) - var(--innerMenuItemMarginBottom)) calc(var(--innerMenuItemSpace) / 2) var(--innerMenuItemMarginBottom);

				.default-menu-item-info {
					width: 100%;

					.fake-image-cont {
						display: block;
						width: var(--infoMenuImageWidth);

						.fake-image {
							display: block;
							width: 100%;
							padding-top: var(--infoMenuImageProportion);
						}
					}
				}

				.menu-item-info {
					display: flex;
					align-items: flex-start;
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					opacity: 0;

					.image {
						width: var(--infoMenuImageWidth);
						border-radius: var(--sp2x);
						overflow: hidden;

						.imageCont {
							--imagePaddingTop: var(--infoMenuImageProportion);
						}
					}

					.info {
						display: flex;
						align-items: flex-start;
						justify-content: center;
						flex-direction: column;
						flex: 1;
						height: 100%;
						margin-left: var(--infoMenuInfoMarginLeft);

						.info-title {
							margin-bottom: var(--infoMenuTitleMarginBottom);
						}
					}

					&.active {
						opacity: 1;
						transition: opacity var(--trTime);
					}
				}
			}
		}

		//! Default Menu
		&.default-menu {
			max-width: var(--defaultMenuMaxWidth);

			.menu-inner-item {
				width: 50%;
			}
		}
	}

	&:before {
		content: '';
		position: absolute;
		top: 100%;
		left: 50%;
		width: 140%;
		height: var(--headerPaddingV);
		transform: translateX(-50%);
		pointer-events: none;
	}

	@media (hover: hover) {
		&:hover {
			> span,
			> [class^='giz-'] {
				color: var(--primaryColor2);
			}

			> [class^='giz-'] {
				transform: rotate(180deg);
			}

			.menu-inner-cont,
			&:before {
				opacity: 1;
				transition: all var(--trTime);
				pointer-events: all;
			}
		}
	}

	&.active {
		> span,
		> [class^='giz-'] {
			color: var(--primaryColor2);
		}
	}

	@media not all and (hover: hover) {
		&.opened {
			> span,
			> [class^='giz-'] {
				color: var(--primaryColor2);
			}

			> [class^='giz-'] {
				transform: rotate(180deg);
			}

			.menu-inner-cont,
			&:before {
				opacity: 1;
				transition: all var(--trTime);
				pointer-events: all;
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--menuItemMarginH: var(--sp5x);
		--menuItemIconMarginLeft: var(--sp1x);
		--menuInnerContPaddingH: var(--sp6x);
		--menuInnerContPaddingV: var(--sp7x);

		//! Inner Menu Item
		--innerMenuItemMarginBottom: var(--sp4x);

		//! Icon Menu
		--iconMenuMaxWidth: var(--sp93x);
		--iconMenuItemMarginBottom: var(--sp3x);
		--iconMenuImageSize: var(--sp4x);
		--iconMenuImageMarginRight: var(--sp2x);

		//! Sub Menu
		--subMenuMaxWidth: var(--sp154x);
		--subMenuGroupMarginBottom: var(--sp5x);

		//! Info Menu
		--infoMenuMaxWidth: var(--sp154x);
		--infoMenuMaxWidthLangDe: var(--sp142x);
		--infoMenuMarginTop: var(--sp12x);
		--infoMenuImageWidth: 37.28%;
		--infoMenuInfoMarginLeft: var(--sp7x);
		--infoMenuTitleMarginBottom: var(--sp2x);

		//! Default Menu
		--defaultMenuMaxWidth: var(--sp81x);
		--menuRightPosition: calc(-1 * var(--sp2x));
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--menuItemMarginH: var(--sp4x);
		--menuItemIconMarginLeft: var(--sp1x);
		--menuInnerContPaddingH: var(--sp5x);
		--menuInnerContPaddingV: var(--sp6x);

		//! Inner Menu Item
		--innerMenuItemMarginBottom: var(--sp3x);

		//! Icon Menu
		--iconMenuMaxWidth: var(--sp72x);
		--iconMenuItemMarginBottom: var(--sp2x);
		--iconMenuImageSize: var(--sp3x);
		--iconMenuImageMarginRight: var(--sp1x);

		//! Sub Menu
		--subMenuMaxWidth: var(--sp117x);
		--subMenuGroupMarginBottom: var(--sp4x);

		//! Info Menu
		--infoMenuMaxWidth: var(--sp117x);
		--infoMenuMaxWidthLangDe: var(--sp100x);
		--infoMenuMarginTop: var(--sp10x);
		--infoMenuImageWidth: 39.18%;
		--infoMenuInfoMarginLeft: var(--sp4x);
		--infoMenuTitleMarginBottom: var(--sp2x);

		//! Default Menu
		--defaultMenuMaxWidth: var(--sp61x);
		--menuRightPosition: calc(-1 * var(--sp2x));
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--menuItemMarginH: var(--sp4x);
		--menuItemIconMarginLeft: var(--sp1x);
		--menuInnerContPaddingH: var(--sp5x);
		--menuInnerContPaddingV: var(--sp6x);

		//! Inner Menu Item
		--innerMenuItemMarginBottom: var(--sp3x);

		//! Icon Menu
		--iconMenuMaxWidth: var(--sp71x);
		--iconMenuItemMarginBottom: var(--sp2x);
		--iconMenuImageSize: var(--sp3x);
		--iconMenuImageMarginRight: var(--sp1x);

		//! Sub Menu
		--subMenuMaxWidth: var(--sp117x);
		--subMenuGroupMarginBottom: var(--sp4x);

		//! Info Menu
		--infoMenuMaxWidth: var(--sp117x);
		--infoMenuMaxWidthLangDe: var(--sp97x);
		--infoMenuMarginTop: var(--sp10x);
		--infoMenuImageWidth: 39.18%;
		--infoMenuInfoMarginLeft: var(--sp4x);
		--infoMenuTitleMarginBottom: var(--sp2x);

		//! Default Menu
		--defaultMenuMaxWidth: var(--sp61x);
		--menuRightPosition: calc(-1 * var(--sp8x));
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--menuItemMarginH: var(--sp2x);
		--menuItemIconMarginLeft: var(--sp1x);
		--menuInnerContPaddingH: var(--sp4x);
		--menuInnerContPaddingV: var(--sp5x);

		//! Inner Menu Item
		--innerMenuItemMarginBottom: var(--sp3x);

		//! Icon Menu
		--iconMenuMaxWidth: var(--sp63x);
		--iconMenuItemMarginBottom: var(--sp2x);
		--iconMenuImageSize: var(--sp3x);
		--iconMenuImageMarginRight: var(--sp1x);

		//! Sub Menu
		--subMenuMaxWidth: var(--sp103x);
		--subMenuGroupMarginBottom: var(--sp4x);

		//! Info Menu
		--infoMenuMaxWidth: var(--sp104x);
		--infoMenuMaxWidthLangDe: var(--sp93x);
		--infoMenuMarginTop: var(--sp8x);
		--infoMenuImageWidth: 31.68%;
		--infoMenuInfoMarginLeft: var(--sp5x);
		--infoMenuTitleMarginBottom: var(--sp2x);

		//! Default Menu
		--defaultMenuMaxWidth: var(--sp54x);
		--menuRightPosition: calc(-1 * var(--sp15x));
	}
`;

export default MenuItemStyle;
